
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.226 6.452h-1.518v-.96a.708.708 0 10-1.416 0v.96h-.166a1.942 1.942 0 00-2.06 2.066c.014.707.54 1.227.963 1.563.459.364 1.053.707 1.588 1.016l.03.017c.57.329 1.075.622 1.443.914.406.323.428.479.428.484v.013a.596.596 0 01-.606.606H8.774a.708.708 0 100 1.417h1.518v.961a.708.708 0 101.416 0v-.961h.185a2.014 2.014 0 002.041-2.043c-.003-.719-.535-1.246-.963-1.586-.459-.364-1.053-.707-1.588-1.016l-.03-.017c-.57-.329-1.075-.622-1.443-.914-.406-.323-.428-.478-.428-.484 0-.018 0-.037-.002-.056a.525.525 0 01.565-.565.704.704 0 00.056.002h3.125a.708.708 0 000-1.417z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 2a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM5.991 5.491A7.083 7.083 0 1116.01 15.51 7.083 7.083 0 015.99 5.49z","fill":"currentColor"}})])
          )
        }
      }
    